/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Container, Row, Col } from "react-awesome-styled-grid";

type NavigationWidth = {
  xs: number;
  md: number;
  lg: number;
};

type NavigationOnSideProps = {
  navigationWidth?: NavigationWidth;
  navigation: React.ReactNode;
  children: React.ReactNode;
  breadcrumbs?: React.ReactNode;
};

const defaultNavigationBreakpointsWidth = {
  xs: 4,
  md: 2,
  lg: 2.5,
};

export function NavigationOnSide({
  navigation,
  children,
  breadcrumbs,
  navigationWidth = defaultNavigationBreakpointsWidth,
}: NavigationOnSideProps) {
  return (
    <Container>
      {breadcrumbs}
      <Row>
        <Col
          css={{ paddingRight: "0.5rem" }}
          xs={navigationWidth.xs}
          md={navigationWidth.md}
          lg={navigationWidth.lg}
        >
          {navigation}
        </Col>

        <Col
          css={{ paddingLeft: "0.5rem" }}
          xs={navigationWidth.xs}
          md={8 - navigationWidth.md}
          lg={12 - navigationWidth.lg}
        >
          {children}
        </Col>
      </Row>
    </Container>
  );
}
